<template>
  <div id="start">
    <ul class="scene">
      <!-- Ground -->
      <li class="layer scene__layer scene__layer--ground" data-depth="-0.2">
        <div class="scene__illus scene__illus--ground"></div>
      </li>

      <!-- Foreground (people) -->
      <li class="layer scene__layer scene__layer--foreground" data-depth="0.0">
      </li>

      <!-- Middleground (buildings) -->
      <li class="layer scene__layer scene__layer--midground" data-depth="0.2">
      </li>

      <!-- Background (landscape) -->
      <li class="layer scene__layer scene__layer--background" data-depth="1">
        <img class="scene__illus scene__illus--background" src="../../assets/svg/start/background.svg" alt="">
      </li>

      <!-- Sky  -->
      <li class="scene__sky">
        <img class="scene__cloud scene__cloud--first" src="../../assets/svg/scene__clouds-1.svg" alt="">
        <img class="scene__cloud scene__cloud--second" src="../../assets/svg/scene__clouds-1.svg" alt="">
        <img class="scene__cloud scene__cloud--third" src="../../assets/svg/scene__clouds-2.svg" alt="">
        <img class="scene__cloud scene__cloud--fourth" src="../../assets/svg/scene__clouds-1.svg" alt="">
        <img class="scene__sun" src="../../assets/svg/scene__sun.svg" alt="">
      </li>
    </ul>


    <div class="start-message">
      <div class="start-message__frame">
        <div class="start-message__frame-wrap">

          <h1 class="start-message__title">The Eco-Schools’ Quiz</h1>

          <p>Welcome to The Eco-Schools’ Quiz! Explore the 6 different school areas and answer 30 eco-inspired, multiple-choice questions. Each question shows a great example of how you and your school can make a difference. Whether you’re taking on the quiz single-handedly, or working as a team, we hope you have lots of fun, learn some interesting facts, and leave feeling inspired! Good luck!</p>

          <button type="button" class="start-trigger" v-on:click="goStart">
            <img class="start-trigger__image" src="../../assets/svg/start/button.svg" alt="">
            <span class="start-trigger__text">Start</span>
          </button>

        </div>
      </div>
    </div>

    <div class="start-privacy">
      <a class="start-privacy__link" href="https://www.eco-schools.org.uk/privacy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
    </div>
  </div>
</template>

<script>
  import routes from '../../routes'
  import { ParallaxClass } from '../../classes/ParallaxClass'
  import { Clouds } from '../../classes/Clouds'
  import { Animations } from '../../classes/Animations'
  import { Scores } from '../../classes/Scores'

  const parallax = new ParallaxClass()
  const clouds = new Clouds([
    [ '.scene__cloud--first', 130 ],
    [ '.scene__cloud--second', 90 ],
    [ '.scene__cloud--third', 80 ],
    [ '.scene__cloud--fourth', 110 ]
  ])
  const animations = new Animations()
  const scores = new Scores()

  export default {
    name: 'view-start',
    methods: {
      goStart: function () {
        let path = ''
        for (let i = 0; i < routes.length; i++) {
          if (routes[i].type === 'scene') {
            path = routes[i]
            break
          }
        }

        scores.clearAnswers()
        this.$router.push({ name: path.name })
      },
      privacyPosition: function () {
        let pos = '0'
        let vpHeight = window.innerHeight
        let privacyLink = document.querySelector('.start-privacy')
        if (privacyLink) {
          if (window.matchMedia('(max-width: 1024px)').matches) {
            pos = '0'
          } else if (window.matchMedia('(max-width: 1366px) and (max-height: 768px)').matches) {
            pos = ((768 - vpHeight) / 2) + 'px'
          } else if (window.matchMedia('(min-width: 1367px) and (max-height: 1080px)').matches) {
            pos = ((1080 - vpHeight) / 2) + 'px'
          }

          privacyLink.style.bottom = pos
        }
      }
    },
    activated () {
      this.$nextTick(() => {
        setTimeout(() => {
          parallax.addToPage(this.$route.name)
          clouds.animate(this.$route.name)

          window.addEventListener('resize', () => this.privacyPosition())
          this.privacyPosition()
        }, 500)
      })
    },
    deactivated () {
      parallax.disable()
      clouds.disable()
      animations.disable()
    }
  }
</script>



// WEBPACK FOOTER //
// Start.vue?fffba4b8